<div class="te-col-center">
    <mat-card class="te-col-center te-panel" [ngStyle]="loggingIn && {'background-color': 'rgba(233,131,0,0.1)'}">
        <mat-progress-bar *ngIf="loggingIn" mode="indeterminate"></mat-progress-bar>
        <h2 class="te-text" style="text-align: center; margin: 20px;"><span [innerHTML]="'TwoFTitle' | translate"></span></h2>

        <div *ngIf="errorMessage" class="te-form-600 te-alert-danger" style="margin-bottom: 20px;" [@dropIn]>
            <span [innerHTML]="errorMessage | translate"></span>
        </div>
        <div *ngIf="successMessage" class="te-form-600 te-alert-info" style="margin-bottom: 20px;" [@dropIn]><span [innerHTML]="successMessage | translate"></span></div>

        <div class="te-text te-row-wrap" style="text-align: left; margin: 20px;"><span  *ngIf="isPINRegistered" [innerHTML]="'TwoFTitletxt' | translate"></span><span *ngIf="!isPINRegistered" [innerHTML]="'TwoFTitletxt1' | translate"></span></div>
        <mat-form-field appearance="fill" class="te-form-350">
            <mat-label>{{'SelectSignInOption'|translate}}</mat-label>
            <mat-select [(ngModel)]="signInOption" (selectionChange)="optionChanged()" [disabled]="loggingIn ||(signInOption === 'questions' && loadingQuestions)">
                <!-- <mat-option>{{'SelectSignInOption'|translate}}</mat-option> -->
                <mat-option *ngFor="let option of login.loginOptions" [value]="option.name">
                    {{ option.desc | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" *ngIf="signInOption === 'password'" class="te-form-350">
            <mat-label>{{'Password'|translate}}</mat-label>
            <input matInput name="b_field" [formControl]="password" [type]="hidePassword ? 'password' : 'text'"
                   autocomplete="off" (keyup.enter)="submit2FLogin()" spellcheck="false" [readonly]="loggingIn" />
            <mat-icon matSuffix style="cursor: pointer;" (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>

        <div class="te-col-center" style="width: 100%;" *ngIf="signInOption === 'questions' && login.securityQuestions">
            <span class="te-form-350">{{ login.securityQuestions[0].securityQuestion }}</span>
            <mat-form-field appearance="fill" class="te-form-350">
                <mat-label>{{'Answer'|translate}}</mat-label>
                <input matInput name="c_field" [formControl]="question1" [type]="hideQuestion1 ? 'password' : 'text'"
                       autocomplete="off" (keyup.enter)="questionTwo.focus()" spellcheck="false" [readonly]="loggingIn" />
                <mat-icon matSuffix style="cursor: pointer;" (click)="hideQuestion1 = !hideQuestion1">{{hideQuestion1 ? 'visibility_off' : 'visibility'}}</mat-icon>
                <!--<mat-error>{{'SecurityFailureMsg'|translate}}</mat-error>-->
            </mat-form-field>
            <span class="te-form-350">{{ login.securityQuestions[1].securityQuestion }}</span>
            <mat-form-field appearance="fill" class="te-form-350">
                <mat-label>{{'Answer'|translate}}</mat-label>
                <input #questionTwo matInput name="d_field" [formControl]="question2" [type]="hideQuestion2 ? 'password' : 'text'"
                       autocomplete="off" (keyup.enter)="submit2FLogin()" spellcheck="false" [readonly]="loggingIn" />
                <mat-icon matSuffix style="cursor: pointer;" (click)="hideQuestion2 = !hideQuestion2">{{hideQuestion2 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
        </div>

        <div *ngIf="(signInOption === 'questions' && !login.securityQuestions && loadingQuestions)">
            <mat-spinner mode="indeterminate"></mat-spinner>
        </div>

        <div *ngIf="(signInOption === 'external_email') && (loadingEmailSentStatus)">
            <mat-spinner mode="indeterminate"></mat-spinner>
        </div>

        <div class="te-col-center" style="width: 100%;" *ngIf="(signInOption === 'external_email') && (emailSent) && (!loadingEmailSentStatus)">
            <span class="te-form-350" style="text-align: left; font-size: 13px; font-weight: bold; font-style: italic;">
                <!--Please provide the Identification Code sent to your External Email Address from SRM_NoReply@te.com:-->
                <span [innerHTML]="'ExtTxtOTP' | translate:translateValue"></span>
            </span>
            <mat-form-field appearance="fill" class="te-form-350">
                <mat-label>{{'ExtLblOTP'|translate}}</mat-label>
                <input matInput name="f_field" [formControl]="emailPasscode" required 
                       [type]="hideEmailPasscode ? 'password' : 'text'" autocomplete="off" (keyup.enter)="submitLogin()" [readonly]="loggingIn"
                       spellcheck="false" />
                <mat-icon matSuffix style="cursor: pointer;" (click)="hideEmailPasscode = !hideEmailPasscode">{{hideEmailPasscode ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <span class="te-form-350" style="text-align: left; font-size: 13px;">

                {{'ExtTxtOTP1'|translate}}&nbsp;<!--Check whether an email from <b>SRM_NoReply@te.com</b> ended up in your "spam" or "junk" folders.-->
                <span [innerHTML]="'ExtTxtOTP5' | translate:translateValue"></span>
            </span>
            <!--<span [innerHTML]="errorMessage | translate:translateValue"></span>-->

            <span class="te-form-350" style="text-align: center;">
                <button mat-button (click)="sendNewEmail()" [disabled]="!userId || loggingIn || loadingEmailSentStatus || resendDisabled" [style.color]="(!userId || loggingIn || loadingEmailSentStatus || resendDisabled) ? 'gray' : '#3DB7E4'">{{'ExtTxtOTP2'|translate}}</button>
            </span>
            <div class="te-form-350 te-row-end te-vert-spacer" style="margin: 20px 0;">
            <button mat-raised-button class="te-button-blue" (click)="submit2FLogin()" [disabled]="!userId || loggingIn || emailPasscode.invalid">{{ 'BtnSubmit' | translate}}</button>
            <button mat-raised-button class="te-button-gray te-left-spacer" (click)="cancel()" [disabled]="!userId || loggingIn || loadingEmailSentStatus">
                {{'BtnCancel'|translate}}
            </button>
        </div>
        </div>

        <div *ngIf="(signInOption !== 'external_email')"  class="te-form-350 te-row-end" style="margin: 20px 0;">
            <button mat-raised-button class="te-button-blue" [disabled]="loggingIn || (password.invalid &&
                                    question1.invalid && question2.invalid)"
                    (click)="submit2FLogin()">
                <!--{{'SignIn'|translate}}--> {{ btnDynamic | translate}}
            </button>

            <button mat-raised-button class="te-button-gray te-left-spacer" (click)="cancel()" [disabled]="loggingIn">  {{'BtnCancel'|translate}}</button>
        </div>

        <div *ngIf="isPINRegistered" class="te-form-600">
            <span (click)="passwordResetPIN()" [innerHTML]="'PinOptionTxt'|translate"></span>
        </div>
    </mat-card>
</div>
